/**
 * 翔远智能称量监控系统 - 主入口（展会一体机版）
 * 参照 zhaofu_excel_typescript 项目风格
 */

/// <reference path="./src/types/miniui.d.ts" />
/// <reference path="./src/types/scada.d.ts" />

import { startBackgroundService } from "./src/background";

// 全局变量
let maintab: any;
let lefttree: any;
let mainToolbar: any;
let activeWindow: Window | null = null;

// 工具栏按钮
let addBtn: any, removeBtn: any, saveBtn: any, searchBtn: any, printReportBtn: any, exportcsvBtn: any;

// 皮肤和尺寸选择器
let selectSkin: HTMLSelectElement;
let selectMode: HTMLSelectElement;

/**
 * 页面加载完成后初始化
 */

window.onload = function() {
    console.log("[App] 页面加载完成，开始初始化...");
    
    // 设置默认admin用户（免登录，参照zhaofu）
    document.cookie = "LOGIN_USER_ID=admin; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/";
    (window as any).mini_debugger = false;
    
    // 解析MiniUI组件（必须在 miniui.js 加载完成后执行）
    mini.parse();
    console.log("[App] mini.parse() 完成");
    
    // 获取组件引用
    maintab = mini.get("maintab");
    lefttree = mini.get("lefttree");
    mainToolbar = mini.get("toolbar1");
    
    addBtn = mini.get("add");
    removeBtn = mini.get("remove");
    saveBtn = mini.get("save");
    searchBtn = mini.get("search");
    printReportBtn = mini.get("printReport");
    exportcsvBtn = mini.get("exportcsv");
    
    selectSkin = document.getElementById("selectSkin") as HTMLSelectElement;
    selectMode = document.getElementById("selectMode") as HTMLSelectElement;
    
    if (!maintab || !lefttree) {
        console.error("[App] 核心组件获取失败", { maintab, lefttree });
        return;
    }
    
    console.log("[App] 组件获取成功");
    
    // 自动打开生产监控主界面
    (function() {
        const e = "tab$P_MAIN_VIEW";
        let t = maintab.getTab(e);
        if (!t) {
            t = { name: e, title: "生产监控", url: "/forms/P_MAIN_VIEW.html", showCloseButton: false, _isMonitor: true, refreshOnClick: false };
            maintab.addTab(t);
            console.log("[App] 自动打开生产监控主界面");
        }
        maintab.activeTab(t);
    })();
    
    // 绑定皮肤切换事件
    if (selectSkin) {
        selectSkin.value = getCookie("miniuiSkin") || "gray";
        selectSkin.onchange = function(this: HTMLSelectElement) {
            onSkinChange(this.value);
        };
    }
    
    // 绑定尺寸切换事件
    if (selectMode) {
        selectMode.value = getCookie("miniuiMode") || "medium";
        selectMode.onchange = function(this: HTMLSelectElement) {
            onModeChange(this.value);
        };
    }
    
    // 菜单选择事件 - 参照zhaofu的menuclick
    lefttree.on("nodeselect", menuClick);
    
    // Tab切换事件
    maintab.on("activechanged", onTabActiveChanged);
    maintab.on("tabload", onTabLoad);
    
    // 关键修复：tab 关闭时取消左侧菜单树对应节点的选中状态。
    // 否则节点保持选中，再次点击同一菜单不会触发 nodeselect，打不开窗口。
    maintab.on("closeclick", function(e: any) {
        const tab = e.tab;
        if (tab && tab._nodeid && lefttree) {
            const node = lefttree.getNode(tab._nodeid);
            if (node && lefttree.isSelectedNode(node)) {
                lefttree.selectNode(null, false);
            }
        }
    });
    
    // 鼠标中键关闭Tab + 鼠标滚动Tab - 参照zhaofu
    initTabMouseEvents();
    
    // 更新时间
    updateTime();
    setInterval(updateTime, 1000);
    
    console.log("[App] 翔远智能称量监控系统初始化完成");
    
    // 启动后台服务（全局监听 PLC 配方触发、自动记录报表）
    startBackgroundService();
    console.log("[App] BackgroundService started");

    // 绑定浮动工具栏按钮点击事件
    initFloatToolbar();

    // 全局加载系统设置到 localStorage，供各 iframe 页面共享
    // 延迟执行，避免和 iframe 初始化冲突导致主监控页重新加载
    setTimeout(() => {
        loadSystemSettingsToLocal();
    }, 500);
};

/**
 * 菜单点击处理 - 参照zhaofu的menuclick
 */
function menuClick(e: any): void {
    if (!e.isLeaf) return;
    
    const node = e.node;
    const id = 'tab$' + node.PGM_ID;
    
    let tab = maintab.getTab(id);

    // 关键修复：如果 tab 存在但 iframe 已销毁（被用户关闭过），
    // getTab() 仍返回旧对象，activeTab() 会失效。先 removeTab 再重新创建。
    if (tab) {
        const iframe = maintab.getTabIFrameEl(tab);
        if (!iframe) {
            maintab.removeTab(tab);
            tab = null;
        }
    }

    if (!tab) {
        // 初始化工具栏状态（默认全部禁用）
        inittoolbar({ add: false, remove: false, save: false, search: false, printReport: false, outportCSV: false });
        
        tab = {};
        tab._nodeid = node.PGM_ID;
        tab._node = node;
        tab.name = id;
        tab.title = node.PGM_NM_CN;
        tab.showCloseButton = true;
        
        // 参照zhaofu的页面路径处理
        if (!node.STARTPARAM || node.STARTPARAM === " ") {
            node.STARTPARAM = 'index.html';
        }
        else{
            tab.url = "/forms/" + node.STARTPARAM;
        tab.refreshOnClick = false;
        }
        
        maintab.addTab(tab);
    }
    
    maintab.activeTab(tab);
}

/**
 * Tab激活改变事件 - 参照zhaofu的ontabactivechanged
 */
function onTabActiveChanged(e: any): void {
    const tabs = e.sender;
    const tab = tabs.getActiveTab();

    // 切换 Tab 时，关闭主监控页的配方弹窗（如果打开的话）
    const allTabs = tabs.getTabs();
    for (const t of allTabs) {
        if (t._isMonitor) {
            const iframe = tabs.getTabIFrameEl(t);
            if (iframe && iframe.contentWindow) {
                const win = iframe.contentWindow as any;
                if (win.closeRecipeModal) {
                    win.closeRecipeModal();
                }
            }
            break;
        }
    }

    // 首先禁用全部工具栏
    inittoolbar({ add: false, remove: false, save: false, search: false, printReport: false, outportCSV: false });
    
    if (!tab) {
        // 没有tab时选中根节点
        const tree = lefttree;
        const rootNode = tree.getRootNode();
        if (rootNode && rootNode.children && rootNode.children.length > 0) {
            const firstNode = rootNode.children[0];
            if (firstNode && !tree.isSelectedNode(firstNode)) {
                tree.selectNode(firstNode);
            }
        }
        activeWindow = null;
        return;
    }
    
    // 同步左侧菜单选中状态
    const tree = lefttree;
    const node = tree.getNode(tab._nodeid);
    if (node && !tree.isSelectedNode(node)) {
        tree.selectNode(node);
    }
    
    // 获取iframe窗口并刷新工具栏状态
    const iframe = tabs.getTabIFrameEl(tab);
    if (iframe) {
        activeWindow = iframe.contentWindow;
        const win = activeWindow as any;
        if (win && win.toolbar_status) {
            inittoolbar(win.toolbar_status);
        }
    }
}

/**
 * Tab加载完成事件 - 参照zhaofu的tabloaded
 */
function onTabLoad(e: any): void {
    const iframe = maintab.getTabIFrameEl(e.index);
    activeWindow = iframe ? iframe.contentWindow : null;
    
    if (activeWindow) {
        const win = activeWindow as any;
        
        // 执行权限检查（参照zhaofu）
        if (win.auth_check && e.tab._node) {
            win.auth_check(
                e.tab._node.ADD, 
                e.tab._node.REMOVE, 
                e.tab._node.SAVE, 
                e.tab._node.PRINTREPORT, 
                e.tab._node.OUTPORTCSV
            );
        }
        
        // 扫描工具栏状态
        toolbarScan();
        
        // 监听DataGrid事件，自动扫描工具栏
        if (win.mini && win.mini.components) {
            const components = win.mini.components;
            for (const key in components) {
                if (components.hasOwnProperty(key)) {
                    const v = components[key];
                    if (v instanceof win.mini.DataGrid || v instanceof win.mini.TreeGrid) {
                        v.on("load", toolbarScan);
                        v.on("addrow", toolbarScan);
                        v.on("removerow", toolbarScan);
                        v.on("updaterow", toolbarScan);
                        v.on("cellbeginedit", function() { 
                            if (win.toolbar_status) win.toolbar_status.printReport = false;
                        });
                        v.on("cellendedit", toolbarScan);
                    }
                }
            }
        }
        
        toolbarScan();
        
        // 根据toolbar_status初始化工具栏
        if (win.toolbar_status) {
            inittoolbar(win.toolbar_status);
        }
    }
}

/**
 * 扫描工具栏状态 - 参照zhaofu的toolbarScan
 */
function toolbarScan(): void {
    if (activeWindow && (activeWindow as any).toolbarScan) {
        (activeWindow as any).toolbarScan();
    }
}

/**
 * 初始化工具栏 - 参照zhaofu的inittoolbar
 */
function inittoolbar(status: any): void {
    const username = getCookie("LOGIN_USER_ID");
    
    // admin用户拥有所有权限
    if (username === "admin") {
        if (addBtn) addBtn.setEnabled(true);
        if (removeBtn) removeBtn.setEnabled(true);
        if (saveBtn) saveBtn.setEnabled(true);
        if (searchBtn) searchBtn.setEnabled(true);
        if (printReportBtn) printReportBtn.setEnabled(true);
        if (exportcsvBtn) exportcsvBtn.setEnabled(true);
    } else {
        if (addBtn) addBtn.setEnabled(status.add);
        if (removeBtn) removeBtn.setEnabled(status.remove);
        if (saveBtn) saveBtn.setEnabled(status.save);
        if (searchBtn) searchBtn.setEnabled(status.search);
        if (printReportBtn) printReportBtn.setEnabled(status.printReport);
        if (exportcsvBtn) exportcsvBtn.setEnabled(status.outportCSV);
    }
}

/**
 * 工具栏按钮点击 - 参照zhaofu的toolbaraction
 * 优先调用 Actions 对象，再尝试 defaultActions，最后尝试全局函数
 */
(window as any).toolbaraction = function(e: any): void {
    const sender = e.sender;
    if (!sender || !sender.id || !activeWindow) return;
    
    const win = activeWindow as any;
    
    // 1. 优先调用页面上的 Actions 对象（页面自定义实现）
    if (win.Actions && typeof win.Actions[sender.id] === 'function') {
        win.Actions[sender.id]();
        return;
    }
    
    // 2. 尝试调用 defaultActions（默认实现）
    if (win.defaultActions && typeof win.defaultActions[sender.id] === 'function') {
        win.defaultActions[sender.id]();
        return;
    }
    
    // 3. 向后兼容：直接调用全局函数（旧架构）
    if (typeof win[sender.id] === 'function') {
        win[sender.id]();
    }
};

/**
 * 皮肤切换 - 参照zhaofu
 */
function onSkinChange(skin: string): void {
    document.cookie = "miniuiSkin=" + skin + ";path=/;max-age=31536000";
    const lskin = document.getElementById("lskin") as HTMLLinkElement;
    if (lskin) {
        const basePath = (window as any).bootPATH || '/scripts/';
        lskin.href = basePath + "miniui/themes/" + skin + "/skin.css";
    }
    
    // 同步更新所有iframe内的皮肤
    const tabs = maintab.getTabs();
    tabs.forEach(function(tab: any) {
        const iframe = tab._iframeEl;
        if (iframe && iframe.contentDocument) {
            const iframeSkin = iframe.contentDocument.getElementById("lskin") as HTMLLinkElement;
            if (iframeSkin) {
                const basePath = (window as any).bootPATH || '/scripts/';
                iframeSkin.href = basePath + "miniui/themes/" + skin + "/skin.css";
            }
        }
    });
}

/**
 * 尺寸切换 - 参照zhaofu
 */
function onModeChange(mode: string): void {
    document.cookie = "miniuiMode=" + mode + ";path=/;max-age=31536000";
    const lmode = document.getElementById("lmode") as HTMLLinkElement;
    if (lmode) {
        const basePath = (window as any).bootPATH || '/scripts/';
        lmode.href = basePath + "miniui/themes/default/" + mode + "-mode.css";
    }
    
    // 同步更新所有iframe内的尺寸
    const tabs = maintab.getTabs();
    tabs.forEach(function(tab: any) {
        const iframe = tab._iframeEl;
        if (iframe && iframe.contentDocument) {
            const iframeMode = iframe.contentDocument.getElementById("lmode") as HTMLLinkElement;
            if (iframeMode) {
                const basePath = (window as any).bootPATH || '/scripts/';
                iframeMode.href = basePath + "miniui/themes/default/" + mode + "-mode.css";
            }
        }
    });
}

/**
 * 初始化Tab鼠标事件 - 参照zhaofu
 * 鼠标中键关闭Tab + 鼠标滚动Tab
 */
function initTabMouseEvents(): void {
    const mainTabEl = maintab.getEl();
    
    // 鼠标中键关闭Tab
    mainTabEl.addEventListener("mouseup", function(e: any) {
        const tab = maintab.getTabByEvent(e);
        if (!tab) return;
        if (e.button === 1) { // 中键
            const tabEl = maintab.getTabEl(tab);
            const close = tabEl.querySelector(".mini-tab-close");
            if (close) close.click();
        }
    });
    
    // 鼠标滚轮滚动Tab - 参照zhaofu
    let ltimer: any, rtimer: any;
    mainTabEl.addEventListener("mousewheel", function(e: any) {
        const nav = document.querySelector(".mini-tabs-nav") as HTMLElement;
        if (!nav || nav.style.display === 'none') return;
        
        const left = document.querySelector(".mini-tabs-leftButton") as HTMLElement;
        const right = document.querySelector(".mini-tabs-rightButton") as HTMLElement;
        
        if (e.originalEvent && e.originalEvent.wheelDelta > 0) {
            // 向上滚动 - 向左
            if (left && !ltimer) {
                left.dispatchEvent(new MouseEvent("mousedown"));
                clearTimeout(ltimer);
                ltimer = setTimeout(() => {
                    left.dispatchEvent(new MouseEvent("mouseup"));
                    ltimer = null;
                }, 250);
            }
        } else {
            // 向下滚动 - 向右
            if (right && !rtimer) {
                right.dispatchEvent(new MouseEvent("mousedown"));
                clearTimeout(rtimer);
                rtimer = setTimeout(() => {
                    right.dispatchEvent(new MouseEvent("mouseup"));
                    rtimer = null;
                }, 250);
            }
        }
    });
}

/**
 * 更新时间显示
 */
function updateTime(): void {
    const timeEl = document.getElementById("currentTime");
    if (timeEl) {
        timeEl.textContent = new Date().toLocaleString("zh-CN", {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        });
    }
}

/**
 * 获取Cookie - 参照zhaofu
 */
function getCookie(sName: string): string | null {
    const aCookie = document.cookie.split("; ");
    let lastMatch: string[] | null = null;
    for (let i = 0; i < aCookie.length; i++) {
        const aCrumb = aCookie[i].split("=");
        if (sName === aCrumb[0]) {
            lastMatch = aCrumb;
        }
    }
    if (lastMatch) {
        const v = lastMatch[1];
        if (v === undefined) return v;
        return decodeURIComponent(v);
    }
    return null;
}

/**
 * 初始化浮动工具栏按钮点击事件
 */
function initFloatToolbar(): void {
    const toolbar = document.getElementById('floatToolbar');
    if (!toolbar) return;

    // 监听子 iframe 的系统设置变更消息，自动刷新所有 iframe
    window.addEventListener('message', (e) => {
        if (e.data && e.data.type === 'settingsChanged') {
            const tabs = maintab.getTabs();
            for (const tab of tabs) {
                const iframe = maintab.getTabIFrameEl(tab);
                if (iframe && iframe.contentWindow && iframe.contentWindow.location) {
                    iframe.contentWindow.location.reload();
                }
            }
        }
    });

    const buttons = toolbar.querySelectorAll('.float-btn');
    buttons.forEach((btn) => {
        btn.addEventListener('click', () => {
            const form = (btn as HTMLElement).dataset.form;
            if (!form) return;

            if (form === 'P_TRANSFER') {
                // 发送配方：在主监控页面唤起弹窗
                const tabs = maintab.getTabs();
                let found = false;
                for (const tab of tabs) {
                    if (tab._isMonitor) {
                        // 激活主监控页
                        maintab.activeTab(tab);
                        // 调用页面内的弹窗显示函数
                        setTimeout(() => {
                            const iframe = maintab.getTabIFrameEl(tab);
                            if (iframe && iframe.contentWindow) {
                                const win = iframe.contentWindow as any;
                                if (win.showRecipeModal) {
                                    win.showRecipeModal();
                                }
                            }
                        }, 100);
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    // 主监控页未打开，先打开
                    const tab = { name: 'tab$P_MAIN_VIEW', title: '生产监控', url: '/forms/P_MAIN_VIEW.html', showCloseButton: false, _isMonitor: true, refreshOnClick: false };
                    maintab.addTab(tab);
                    maintab.activeTab(tab);
                    setTimeout(() => {
                        const iframe = maintab.getTabIFrameEl(tab);
                        if (iframe && iframe.contentWindow) {
                            const win = iframe.contentWindow as any;
                            if (win.showRecipeModal) {
                                win.showRecipeModal();
                            }
                        }
                    }, 300);
                }
                return;
            }

            // 其他按钮：打开对应页面
            const id = 'tab$' + form;
            let tab = maintab.getTab(id);
            if (!tab) {
                const titles: Record<string, string> = {
                    'R_TRANSFER': '发送记录',
                    'R_BATCH': '称量报表',
                    'R_CURVE': '曲线记录',
                    'P_COMMAND_PLC': '控制命令'
                };
                tab = {
                    name: id,
                    title: titles[form] || form,
                    url: '/forms/' + form + '.html',
                    showCloseButton: true
                };
                maintab.addTab(tab);
            }
            maintab.activeTab(tab);
        });
    });
}

/**
 * 全局加载系统设置到 localStorage
 * 主页面启动时执行一次，各 iframe 页面直接读取 localStorage 即可
 */
function loadSystemSettingsToLocal() {
    jQuery.ajax({
        url: "php/AjaxService_CM.php?method=getSystemSettings",
        type: "get",
        success: (text: string) => {
            const result: any = mini.decode(text);
            if (result.success && result.data) {
                const cfg = result.data;
                localStorage.setItem("xiangyuan.sys1", String(cfg.SYS_1 ?? 1));
                localStorage.setItem("xiangyuan.sys2", String(cfg.SYS_2 ?? 1));
                localStorage.setItem("xiangyuan.sys3", String(cfg.SYS_3 ?? 1));
                localStorage.setItem("xiangyuan.batchMax", String(cfg.BATCH_SET_MAX ?? 5));
                console.log("[App] 系统设置已加载到 localStorage");
            }
        },
        error: () => {
            console.warn("[App] 系统设置加载失败，使用 localStorage 旧值或默认值");
        }
    });
}

// 热更新支持
// @ts-ignore
if (module && module.hot) {
    // @ts-ignore
    module.hot.accept();
}
